export const BUYER_INPUT = '_buyer';

export const INPUT_KEYS = {
	ACTION_TAKEN: 'action_taken',
	OTHER_ACTION_NAME: 'other_action_name',
	COMMENTS: 'notes',
	STARTING_BID_AMOUNT: 'starting_bid_amount',
	FLOOR_PRICE: 'floor_price',
	PRICE: 'price',
	AMOUNT: 'amount',
	BUYER_AMOUNT: `amount${BUYER_INPUT}`,
	MAX_BID_AMOUNT: 'max_bid_amount',
	BUYER_MAX_BID_AMOUNT: `max_bid_amount${BUYER_INPUT}`,
	CLOSE_DEAL_AMOUNT: 'close_deal_amount',
	BUYER_CLOSE_DEAL_AMOUNT: `close_deal_amount${BUYER_INPUT}`,
	LAUNCH_ABSOLUTE_SALE: 'launch_absolute_sale',
	SEND_TO_MARKETPLACE: 'send_to_marketplace',
	APPLY_DISCOUNT: 'apply_discount',
	MARK_AS_STALLED: 'mark_as_stalled',
	MARK_AS_URGENT: 'mark_as_urgent',
	SEND_TO_REP: 'send_to_rep',
	FIRM: 'firm',
	BUYER_FIRM: `firm${BUYER_INPUT}`,
	SHOW_TO_SELLER: 'show_to_seller',
	SCHEDULED_PRICE_DELAY_HOURS: 'scheduled_price_delay_hours',
	COUNTER_AMOUNT: 'counter_amount',
	DEAL_VALUE: 'deal_value',
	LAUNCH_ABSOLUTE_SALE_AT: 'launch_absolute_sale_at',
	LAUNCH_ABSOLUTE_SALE_CHECK: 'launch_absolute_sale_check',
	AUCTION_ID: 'absolute_sale_auction_id',
	SEND_TO_REP_DISABLED: 'send_to_rep_disabled',
	SOURCE_MODAL: 'source_modal',
	APPLY_COMMENT_UNIVERSALLY: 'apply_comment_universally',
};

export const BIN_TIMING_OPTIONS = [
	{ value: 9, text: 'Right Away' },
	{ value: 1, text: 'After 1 hour' },
	{ value: 2, text: 'After 2 hours' },
	{ value: 3, text: 'After 3 hours' },
	{ value: 4, text: 'After 4 hours' },
	{ value: 5, text: 'After 5 hours' },
	{ value: 6, text: 'After 6 hours' },
	{ value: 7, text: 'After 7 hours' },
	{ value: 8, text: 'After 8 hours' },
];

export const VEHICLE_STATUS = { sold: 'sold' };

export const DEAL_WORKING_TURN = {
	BUY_SIDE: 'buy_side',
	SELL_SIDE: 'sell_side',
};

export const SOURCE_MODAL = {
	MANAGE_DEAL: 'manage_modal',
	MINI_MODAL: 'mini_modal',
	LEGACY_MODAL: 'legacy_modal',
};

export const MANAGE_DEAL_INITIAL_VALUES = {
	[INPUT_KEYS.ACTION_TAKEN]: 'none',
	[INPUT_KEYS.SOURCE_MODAL]: SOURCE_MODAL.MANAGE_DEAL,
};

export const SCOPEABLE_ENTITY_TYPES = {
	ADMIN_USER: 'AdminUser',
	TERRITORY: 'Territory',
};
